/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FullSupporting } from './FullSupporting';
import {
    FullSupportingFromJSON,
    FullSupportingFromJSONTyped,
    FullSupportingToJSON,
} from './FullSupporting';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface FullGetSupportedUsers
 */
export interface FullGetSupportedUsers {
    /**
     * 
     * @type {number}
     * @memberof FullGetSupportedUsers
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof FullGetSupportedUsers
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof FullGetSupportedUsers
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof FullGetSupportedUsers
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof FullGetSupportedUsers
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof FullGetSupportedUsers
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof FullGetSupportedUsers
     */
    version: VersionMetadata;
    /**
     * 
     * @type {Array<FullSupporting>}
     * @memberof FullGetSupportedUsers
     */
    data?: Array<FullSupporting>;
}

/**
 * Check if a given object implements the FullGetSupportedUsers interface.
 */
export function instanceOfFullGetSupportedUsers(value: object): value is FullGetSupportedUsers {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function FullGetSupportedUsersFromJSON(json: any): FullGetSupportedUsers {
    return FullGetSupportedUsersFromJSONTyped(json, false);
}

export function FullGetSupportedUsersFromJSONTyped(json: any, ignoreDiscriminator: boolean): FullGetSupportedUsers {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FullSupportingFromJSON)),
    };
}

export function FullGetSupportedUsersToJSON(value?: FullGetSupportedUsers | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FullSupportingToJSON)),
    };
}

